export default __webpack_public_path__ + "images/gitee.png";